var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h2',{staticClass:"page-title"},[_c('i',{staticClass:"fas fa-home"}),_vm._v(" Dashboard Marketea")])])])])
}]

export { render, staticRenderFns }